/* globals $, Modal */

(function() {
    'use strict';

    if (typeof window.env === 'undefined') {
        window.env = {};
    }

    // console log fix
    if (typeof console === 'undefined') {
        console = {
            log: function() {
            }
        };
    }

    $(document).ajaxError(function(e, xhr) {
        var data = xhr.responseJSON;
        // detect ajax requests that response with a login required status
        // and prompt a redirect to the login page
        if (data && !data.success && data.hasOwnProperty('authRedirect')) {
            if (!promptLoginModal()) {
                // can't locate modal, just redirect to the login page
                window.location = data.authRedirect;
            }
        }
    });

    function promptLoginModal(url) {
        var modal = $('#auth-logged-out-modal');
        modal.find('#auth-link').attr('href', url);
        modal.modal('show');
        return modal.length > 0;
    }

    $(document).ready(function() {

        // country selection
        $('#select-country-dropdown-button').click(function() {
            if ($('.select-country-dropdown').css('display') === 'none') {
                $('.select-country-dropdown').show();
            } else {
                $('.select-country-dropdown').hide();
            }
        });

        var tc;
        $('.select-country-dropdown, #select-country-dropdown-button').mouseout(function() {
            tc = setTimeout(function() {
                $('.select-country-dropdown').hide();
            }, 50);
        });

        $('.select-country-dropdown, #select-country-dropdown-button').mouseover(function() {
            clearTimeout(tc);
        });

        // currency selection
        $('#select-currency-dropdown-button').click(function() {
            var currencyDropdown = $('.select-currency-dropdown');
            if (currencyDropdown.css('display') === 'none') {
                currencyDropdown.show();
            } else {
                currencyDropdown.hide();
            }
        });

        var selectCurrencyMouseOutTimeOut;
        var selectCurrencyDropdown = $('.select-currency-dropdown, #select-currency-dropdown-button');
        selectCurrencyDropdown.mouseout(function() {
            selectCurrencyMouseOutTimeOut = setTimeout(function() {
                $('.select-currency-dropdown').hide();
            }, 50);
        });

        selectCurrencyDropdown.mouseover(function() {
            clearTimeout(selectCurrencyMouseOutTimeOut);
        });

        /**
         * Flexible Dates Matrix: Column & Row Highlighting on Hover
         */
        var faresSearchFlexible = $('#fares-search-flexible');

        faresSearchFlexible.on('mouseenter', 'table.flexible-date-table td', function() {
            var columnIndex = ($(this).index() + 1);

            $(this).parent().find('th').addClass('highlight');
            $(this).parent().find('td').addClass('highlight');

            faresSearchFlexible.find('table.flexible-date-table th:nth-child(' + columnIndex + ')').addClass('highlight');
            faresSearchFlexible.find('table.flexible-date-table td:nth-child(' + columnIndex + ')').addClass('highlight');
        });

        faresSearchFlexible.on('mouseleave', 'table.flexible-date-table td', function() {
            var columnIndex = ($(this).index() + 1);

            $(this).parent().find('th').removeClass('highlight');
            $(this).parent().find('td').removeClass('highlight');

            faresSearchFlexible.find('table.flexible-date-table th:nth-child(' + columnIndex + ')').removeClass('highlight');
            faresSearchFlexible.find('table.flexible-date-table td:nth-child(' + columnIndex + ')').removeClass('highlight');
        });
    });

    /**
     * Toggle an element with custom show/hide text
     *
     * elem       : element with link to show/hide targetted element
     * target     : element to show/hide
     * arrows     : small/smaller (size of the arrows) / false for no arrows
     * showTxt    : link text when targetted element is hidden
     * hideTxt    : 1) false  - text remains same
     *              2) true   - text toggles between Show and Hide
     *              3) 'text' - link text when targetted element is visible
     */
    window.toggleInfo = function(elem, target, arrows, showTxt, hideTxt, force_action) {
        if (!hideTxt) {
            hideTxt = showTxt;
        }
        else if (hideTxt === true) {
            hideTxt = showTxt.replace('Show', 'Hide');
        }

        var showTxtFull = showTxt + ((arrows) ? ' <i class="fa fa-chevron-down"></i>' : '');
        var hideTxtFull = hideTxt + ((arrows) ? ' <i class="fa fa-chevron-up"></i>' : '');

        if ($(target).css('display') === 'none' && (!force_action || force_action !== 'close')) {
            $(elem).html(hideTxtFull);
            $(target).css('display', 'block');
        }
        else if (!force_action || force_action !== 'open') {
            $(elem).html(showTxtFull);
            $(target).css('display', 'none');
        }
    };

    /**
     * Initializing tooltips for elements inside specified selector on given position
     * Available positions: north, south, east, west, north-west, north-east, south-west, south-east
     */
    window.initializeTipsy = function(selector, position) {
        //Removing all previously loaded tooltips ... this doesn't do anything. no object gets the tipsy class
        //$('.tipsy').remove();
        var grav;
        switch (position) {
            case 'north':
                grav = 'n';
                break;
            case 'south':
                grav = 's';
                break;
            case 'east':
                grav = 'e';
                break;
            case 'west':
                grav = 'w';
                break;
            case 'north-west':
                grav = 'nw';
                break;
            case 'north-east':
                grav = 'ne';
                break;
            case 'south-west':
                grav = 'sw';
                break;
            case 'south-east':
                grav = 'se';
                break;
        }

        $(selector + ' .' + position).tipsy(
            {
                gravity: grav,
                opacity: 1,
                html: true
            });
    };

    window.refreshToggling = function() {
        $('.toggleFixed').each(function() {

            $(this).off('click').on('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                var caller = $(this);
                var toggleElement = $(caller.data('target'));

                if (toggleElement.length > 0) {
                    $(caller).trigger('startToggling');
                    $(toggleElement).slideToggle(400, function() {
                        $(caller).trigger('doneToggling');
                    });
                }
            });
        });

        $('.toggle').each(function() {
            $(this).click(function(event) {
                event.preventDefault();

                var caller = $(this);
                var toggleElement = $(caller.attr('rel'));
                if (toggleElement.length > 0) {
                    if (toggleElement.is(':visible')) {
                        return false;
                    }

                    $('.toggleElement').hide();
                    toggleElement.addClass('toggleElement');
                    toggleElement.mouseover(function() {
                        toggleElement.addClass('toggleHoverOn');
                    });

                    toggleElement.mouseout(function() {
                        toggleElement.removeClass('toggleHoverOn');
                    });

                    toggleElement.toggle({
                        duration: 250,
                        queue: false,
                        done: function() {
                            if ($(this).is(':visible')) {
                                setTimeout(function() {
                                    closeToggleElement(toggleElement);
                                }, 1500);
                            }
                        }
                    });
                }
            });
        });

        var closeToggleElement = function(el) {
            if ($(el).hasClass('toggleHoverOn')) {
                setTimeout(function() {
                    closeToggleElement(el);
                }, 500);

            }
            else {
                $(el).removeClass('toggleHoverOn').fadeOut(350);
            }
        };
    };

    $(function() {
        $('.tooltipster').tooltipster({
            contentAsHTML: true
        });
    });
})();

